module.exports = __webpack_public_path__ + "img/completion5.621ee1e1.svg";